import React from 'react';

import { cn } from "cn";

/** Shell for auth/onboarding routes. */
export default function LayoutOnboarding(props: {
    hideLogo?: boolean;
    className?: string;
    children: React.ReactNode;
}) {
    return (
        <>
            <section
                className={cn(
                    'flex min-h-[calc(100vh-5rem)] w-screen flex-col items-center justify-center bg-gray-100 px-4 py-8 text-center',
                    props.className
                )}
            >
                {!props.hideLogo && (
                    <img
                        src="/logo.svg"
                        alt="Grail Talent Logo"
                        className="mx-auto mb-8 block h-auto w-50"
                    />
                )}

                <main className="w-full min-h-[286px]">{props.children}</main>
            </section>
            <footer className="flex h-20 w-full items-center justify-between bg-black p-4 text-white">
                <div className="text-tiny/4">
                    v{import.meta.env.VITE_APP_VERSION}
                </div>
                <div>&copy; Grail Talent</div>
                <div>
                    <a
                        href="https://grail-talent.com/terms"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Terms
                    </a>
                </div>
            </footer>
        </>
    );
}
